import { useDispatch } from 'react-redux';

import { CustomButton } from '../../../../../shared/uiComponents';
import { Eye } from '../../../../../shared/Assets/sessionDetailsSVGs';
import { DTTTargetHistory, TATargetHistory } from './targetHistory';

import { DispatchProperties } from '../../../../../redux/store';
import { TargetTypes } from '../../../../../redux/API/ClientAPIHelpers/programTargetsProperties';
import { setActiveTargetHidden } from '../../../../../redux/State/clientSlice/sessionSlice';

const TargetActions = ({
	id,
	name,
	type,
	closeHandler,
	fetchData,
}: {
	closeHandler: () => void;
	fetchData: () => void;
	id: string;
	name: string;
	type: number;
}) => {
	const dispatch = useDispatch<DispatchProperties>();

	const onHideClick = () => {
		dispatch(setActiveTargetHidden(id));
		closeHandler();
	};

	return (
		<div className="actions">
			<CustomButton title="Hide" buttonType="secondaryGray" startIcon={<Eye />} onClick={onHideClick} />
			{type === TargetTypes.DTT && <DTTTargetHistory targetId={id} targetName={name} fetchData={fetchData} />}
			{type === TargetTypes.TA && <TATargetHistory targetId={id} fetchData={fetchData} />}
		</div>
	);
};

export default TargetActions;
